var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExamListAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 14,
    rx: 2,
    width: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.74730897 1.5 1.24365141-1.43972393c.02084596-.02392638.0033164-.06027607-.02890009-.06027607h-.37807003c-.02226728 0-.04358702.00966258-.05827395.02622699l-1.02571631 1.18757669-1.02571631-1.18757669c-.01421315-.01656441-.03553289-.02622699-.05827395-.02622699h-.37807003c-.03221649 0-.04974605.03634969-.02890009.06027607l1.24365141 1.43972393-1.24365141 1.43972393c-.02084596.02392638-.0033164.06027607.02890009.06027607h.37807003c.02226728 0 .04358702-.00966258.05827395-.02622699l1.02571631-1.18757669 1.02571631 1.18757669c.01421316.01656441.03553289.02622699.05827395.02622699h.37807003c.03221649 0 .04974605-.03634969.02890009-.06027607z",
    fill: "#333",
    fillRule: "nonzero",
    opacity: 0.7,
    stroke: "#fff",
    strokeWidth: 0.5,
    transform: "translate(1.5 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.96070658 0h-.34263347c-.04803732 0-.09362374.02096762-.12303434.05684554l-2.02099831 2.43364137-.96907923-1.16719732c-.02990077-.03587793-.07499702-.05684554-.12303433-.05684554h-.34263348c-.03284184 0-.05097837.03587792-.03088113.06010717l1.34259383 1.61683621c.06274261.07548343.18332607.07548343.24655885 0l2.39402274-2.88374621c.02009724-.0237633.00196071-.05964122-.03088113-.05964122z",
    fill: "#333",
    fillRule: "nonzero",
    opacity: 0.7,
    stroke: "#fff",
    strokeWidth: 0.5,
    transform: "translate(1 9.028906)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.5 3.5c.27614237 0 .5.22385763.5.5v2.5h2.5c.2761424 0 .5.22385763.5.5s-.2238576.5-.5.5h-2.5v2.5c0 .2761424-.22385763.5-.5.5s-.5-.2238576-.5-.5v-2.5h-2.5c-.27614237 0-.5-.22385763-.5-.5s.22385763-.5.5-.5h2.5v-2.5c0-.27614237.22385763-.5.5-.5z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamListAdd);
export default __webpack_public_path__ + "static/media/examListAdd.a1146599b77586fb4bb1cdddcf2eb9ea.svg";
export { ForwardRef as ReactComponent };